"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSDK = void 0;
var react_1 = require("react");
var SDKProvider_1 = require("./SDKProvider");
/**
 * A react hook returning the App SDK.
 *  - The type of SDK varies depending on the location where it is used.
 *  - As it is depending on the context providing the SDK, the hook can only be used within the SDKProvider
 */
function useSDK() {
    var sdk = (0, react_1.useContext)(SDKProvider_1.SDKContext).sdk;
    if (!sdk) {
        throw new Error('SDKContext not found. Make sure this hook is used inside the SDKProvider');
    }
    return sdk;
}
exports.useSDK = useSDK;
